import { createRouter, createWebHashHistory } from 'vue-router'
import { autoLoginByCASId, getRoleList, getProjectInfo, getCenterInfo } from '@/api/public/public'
import { getViewStatus } from '@/api/comments'
import resetSetItem from '@/utils/watchSession';
import axios from 'axios'
import location from '@/utils/location';
import { reactive } from 'vue';
const domain = location.domain();
const html = location.html();

const routes = [
  {
    path: '/tertiary/403',
    name: '403',
    component: () => import('@/views/403.vue')
  },
  {
    path: '/tertiary',
    name: 'layout',
    component: () => import('@/components/layout.vue'),
    children: [
      {
        path: '/tertiary/video',
        name: 'video',
        component: () => import('@/views/video/video.vue'),
      },
      {
        path: '/tertiary/resources',
        name: 'resources',
        component: () => import('@/views/resources/resources.vue'),
      },
      {
        path: '/tertiary/liveBroadcast',
        name: 'liveBroadcast',
        component: () => import('@/views/liveBroadcast/liveBroadcast.vue'),
      },
      {
        path: '/tertiary/ablity',
        name: 'ablity',
        component: () => import('@/views/ablity/ablity.vue'),
      },
      {
        path: '/tertiary/ablity/join',
        name: 'join',
        component: () => import('@/views/ablity/joinList.vue'),
      },
      {
        path: '/tertiary/ablity/review',
        name: 'review',
        component: () => import('@/views/ablity/review.vue'),
      },
      // 活动
      {
        path: '/tertiary/activity',
        name: 'activity',
        component: () => import('@/views/activity/activity.vue'),
      },
      {
        path: '/tertiary/activity/join',
        name: 'activityjoin',
        component: () => import('@/views/activity/joinList.vue'),
      },
      {
        path: '/tertiary/activity/review',
        name: 'activityreview',
        component: () => import('@/views/activity/review.vue'),
      },

      //作业 文章 成果
      {
        path: '/tertiary/task',
        name: 'task',
        component: () => import('@/views/task'),
      },
      {
        path: '/tertiary/task/mark',
        name: 'mark',
        component: () => import('@/views/task/markRecord'),
      },
      {
        path: '/tertiary/task/consult',
        name: 'consult',
        component: () => import('@/views/task/consult'),
      },
      {
        path: '/tertiary/task/requirement',
        name: 'requirement',
        component: () => import('@/views/task/requirement'),
      },
      {
        path: '/tertiary/exchange',
        name: 'exchange',
        component: () => import('@/views/exchange'),
      },
      //额外的交流
      {
        path: '/tertiary/exchangeExtra',
        name: 'exchangeExtra',
        component: () => import('@/views/exchangeExtra'),
      },

      // 项目主页
      {

        path: '/tertiary/projectHostPage',
        name: 'projectHostPage',
        meta: {
          isOpen: true
        },
        component: () => import('@/views/projectHostPage/index.vue'),
      },
      // 区域
      {
        path: '/tertiary/areaMap',
        name: 'areaMap',
        meta: {
          isOpen: true
        },
        component: () => import('@/views/areaMap/areaMap.vue'),
      },
      {
        path: '/tertiary/areaSearch',
        name: 'areaSearch',
        meta: {
          isOpen: true
        },
        component: () => import('@/views/areaMap/areaSearch.vue'),
      },
      // 专家团队
      {
        path: '/tertiary/expertGroup',
        name: 'expertGroup',
        meta: {
          isOpen: true
        },
        component: () => import('@/views/expertGroup/expertGroup.vue'),
      },
      // 作品展播
      {
        path: '/tertiary/workExhibition',
        name: 'workExhibition',
        meta: {
          isOpen: true
        },
        component: () => import('@/views/workExhibition/workExhibition.vue'),
      },
      // 二级页各教学工具列表页
      {
        path: 'secondaryPage',
        name: 'secondaryPage',
        meta: {
          isOpen: true
        },
        component: () => import('@/views/secondaryPageList')
      },
      {
        path: '/tertiary/secondLc',
        name: 'secondLc',
        meta: {
          isOpen: true
        },
        component: () => import('@/views/secondLc/index.vue'),

      }
    ]
  },

]
const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0 }
  },
})
// 路由守卫--start
router.beforeEach((to, from, next) => {
  sessionStorage.removeItem("showSwitchRole");
  sessionStorage.removeItem("isNotice");
  sessionStorage.removeItem("isNoticeAll");
  sessionStorage.removeItem("mandatoryFrontPage");
  localStorage.removeItem('bxkList')
  localStorage.removeItem('bxkZtList')
  if(to.path=='/tertiary/403'){
    next()
    return
  }
  getProjectInfo({ projectId: to.query.projectId }).then(res => {
    if (!res.code) {
      sessionStorage.setItem('projectName', res.data.name)
    }
  })
  getViewStatus({pid: to.query.projectId || JSON.parse(sessionStorage.getItem('loginMessage'))?.projectId, ptCode: 0}).then(res => {
    // 未登录
    if (!res.data.loginStatus) {
      let loginMessage = {
        login: 0,
        userId: null, // 用户id
        username: null, // 用户名
        roleid: null, // 角色id
        realName: null, // 真实姓名
        projectId: to.query.projectId, // 项目id
        authId: null, // 头像
        roletype: null, // 角色种类
        userInfo: {},
        projectInfo: {},
        isTopAdministrator: null, // 是否最高级管理员
      }
      // 存储登录信息
      resetSetItem('loginMessage', JSON.stringify(loginMessage))
      if (to.meta?.isOpen) {
        next()
      } else {
        let showStatus = reactive({ value: {} });
        getViewStatus({
          pid: to.query.projectId,
          ptCode: to.query.ptCode,
        }).then((res) => {
          if (!res.code) {
            showStatus.value = res.data;
            if (!((!showStatus.value.detailStatus && showStatus.value.loginStatus) ||
              showStatus.value.detailStatus)) {
              next({ path: '/tertiary/403' })
            } else {
              next()
            }
          } else {
            next()
          }
        });
      }
      return;
    }
    // 项目登录内
    if (res.data.loginStatus && res.data.memberStatus) {
      const projectIdSS = JSON.parse(sessionStorage.getItem('loginMessage')) ? JSON.parse(sessionStorage.getItem('loginMessage')).projectId : null;
      let loginMessage = {
        login: 0,
        userId: null, // 用户id
        username: null, // 用户名
        roleid: null, // 角色id
        realName: null, // 真实姓名
        projectId: to.query.projectId || res.data.projectId || projectIdSS, // 项目id
        authId: null, // 头像
        roletype: null, // 角色种类
        userInfo: {},
        projectInfo: {},
        isTopAdministrator: null, // 是否最高级管理员
      }
      autoLoginByCASId({ projectId: loginMessage.projectId }).then(res => {
        if (!res.code && res.state === 200 && res.success) {
          if (!res.data.userInfo) {
            getRoleList().then(res1 => {
              if (res1.success) {
                getCenterInfo({
                  roleId: res1.data[0]?.roleId,
                  roleTypeId: res1.data[0]?.roleTypeId
                }).then(res2 => {
                  if (res2.success) {
                    loginMessage.login = 1;
                    loginMessage.userId = null;
                    loginMessage.username = res2.data.username;
                    loginMessage.roleid = res1.data[0]?.roleId;
                    loginMessage.realName = res2.data.realName;
                    loginMessage.projectId = res.data.projectInfo.id;
                    loginMessage.authId = null;
                    loginMessage.roletype = null;
                    loginMessage.userInfo = {};
                    loginMessage.projectInfo = res.data.projectInfo;
                    sessionStorage.setItem('memberId', loginMessage.authId);
                    // //是否是最高级管理员 true false
                    // if (res.data.userInfo?.roletype == '3' && res.data.userInfo?.dictIdLevel2 == res.data.userInfo?.dictIdLevel1) {
                    //   loginMessage.isTopAdministrator = true
                    // } else {
                    //   loginMessage.isTopAdministrator = false
                    // }
                    // 存储登录信息
                    resetSetItem('loginMessage', JSON.stringify(loginMessage))
                    if (!sessionStorage.getItem('roleObj')) {
                      next()
                      getRoleList({ memberId: loginMessage.authId }).then((res) => {
                        if (res.code == 0) {
                          // 传值的时候直接在sessionStorage里拿这两个值
                          sessionStorage.setItem(
                            "roleObj",
                            JSON.stringify({
                              roleId: res.data[0]?.roleId,
                              roleTypeId: res.data[0]?.roleTypeId,
                            })
                          );
                        }
                      });
                    } else {
                      next()
                    };
                  }
                })
              }
            })
          } else {
            loginMessage.login = 1;
            loginMessage.userId = res.data.userInfo?.id;
            loginMessage.username = res.data.userInfo?.username;
            loginMessage.roleid = res.data.userInfo?.roleid;
            loginMessage.realName = res.data.userInfo?.realName;
            loginMessage.projectId = res.data.userInfo?.projectId;
            loginMessage.authId = res.data.userInfo?.authId;
            loginMessage.roletype = res.data.userInfo?.roletype;
            loginMessage.userInfo = res.data.userInfo;
            loginMessage.projectInfo = res.data.projectInfo;
            sessionStorage.setItem('memberId', loginMessage.authId);
            //是否是最高级管理员 true false
            if (res.data.userInfo?.roletype == '3' && res.data.userInfo?.dictIdLevel2 == res.data.userInfo?.dictIdLevel1) {
              loginMessage.isTopAdministrator = true
            } else {
              loginMessage.isTopAdministrator = false
            }
            // 存储登录信息
            resetSetItem('loginMessage', JSON.stringify(loginMessage))
            if (!sessionStorage.getItem('roleObj')) {
              next()
              getRoleList({ memberId: loginMessage.authId }).then((res) => {
                if (res.code == 0) {
                  // 传值的时候直接在sessionStorage里拿这两个值
                  sessionStorage.setItem(
                    "roleObj",
                    JSON.stringify({
                      roleId: res.data[0]?.roleId,
                      roleTypeId: res.data[0]?.roleTypeId,
                    })
                  );
                }
              });
            } else {
              next()
            };
          }
        } else {
          // 清除所有登录信息
          sessionStorage.clear()
        }
      })
      return;
    }
    // 项目登录外
    if (res.data.loginStatus && !res.data.memberStatus) {
      window.location.href = `${domain}personCenter/index.html#/master/index`;
      return;
    }
  });
  // 处理ptCode、stageId、menuRefId
  if (to.query.ptCode) {
    sessionStorage.setItem('ptCode', to.query.ptCode)
  }
  if (to.query.stageId) {
    sessionStorage.setItem('stageId', to.query.stageId)
  }
  if (to.query.menuRefId) {
    sessionStorage.setItem('menuRefId', to.query.menuRefId)
  }
})

// 路由守卫--end
export default router
